<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <!-- Counter Widgets -->
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
          :bordered="false"
          class="header-solid h-full"
          :bodyStyle="{ padding: 0 }"
        >
          <div class="top_box">
            <div class="top_left">
              <div class="avatar-uploader">
                <img
                  v-if="userInfo.avatar"
                  style="border-radius: 50%; width: 100%; height: 100%"
                  :src="userInfo.avatar"
                  alt="avatar"
                />
                <div v-else>
                  <div class="ant-upload-text">LOGO</div>
                </div>
              </div>
              <div class="top_info">
                <div class="top_centont">
                  <div class="top_info_item">
                    <div class="top_item_left">用户账号:</div>
                    <div class="top_item_right">{{ userInfo.account }}</div>
                  </div>
                  <div class="top_info_item">
                    <div class="top_item_left">企业名称:</div>
                    <div class="top_item_right">{{ userInfo.name }}</div>
                  </div>
                  <div class="top_info_item">
                    <div class="top_item_left">用户状态:</div>
                    <div class="top_item_right">
                     <div v-if="userInfo.auditStatus !== 3"><a-tag color="red"> 未认证 </a-tag> <a @click="goToAuth">立即认证</a></div> 
                     <div v-if="userInfo.auditStatus == 3"><a-tag color="green"> 已认证 </a-tag> </div> 
                    </div>
                  </div>
                </div>
                <div class="balance_box">
                  <div style="font-size: 20px">授权码：</div>
                  <div class="top_item_pre" v-if="userInfo.auditStatus == 3">{{ userInfo.authCode }}</div>
                  <a-alert v-if="userInfo.auditStatus !== 3" message="请先完成实名认证后获取,未认证用户无法使用" type="warning" show-icon style="margin-left: 10px"/>
                </div>
              </div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="24" :lg="10" class="mb-24" style="padding: 0">
      
        <a-col :span="24" :lg="24" class="mb-24">
          <a-card :bordered="false">
            <div class="title_box">邀请客户方案</div>
            <div class="first_box">
              <img
                @click="userInfo.auditStatus === 3 && (previewVisible = true)"
                class="first_img"
                :src="posterUrl ? posterUrl : '@/assets/sample_img.png'"
              />
              <div class="first_right">
                <div class="text_box">
                  <div class="text_title" style="margin-bottom: 10px">
                    <div>使用海报引导客户:</div>
                    <div class="copy_text" @click="copyFun(1)">复制话术</div>
                  </div>
                  <div style="font-size: 13px; margin-bottom: 10px">
                    为了加快审核，麻烦提供最近12个月的账单，操作步骤如下：
                  </div>
                  <div class="mb-1" style="font-size: 13px">
                    为了更好给您提供服务，请提供下【微信】【支付宝】最近12个月的账单
                  </div>
                  <div class="mb-1" style="font-size: 13px">
                    具体操作教程，请扫描海报的二维码查看投递。
                  </div>
                </div>
                <div
                  class="copy_text"
                  style="margin-right: 5px"
                  @click="downloadPic"
                >
                  下载海报
                </div>
              </div>
            </div>

            <img />
          </a-card>
        </a-col>
        <a-col :span="24" :lg="24" class="mb-24">
          <a-card :bordered="false">
            <div class="title_box">使用文字版引导</div>
            <div class="text_box">
              <div class="text_title">
                <div>生成年报并授权</div>
                <div style="color: #FF0000; font-size: 14px;">*切勿先发到自己邮箱再转发，否则无法解析</div>
              </div>
              <div style="margin-top: 10px">
                <div style="font-size: 14px; margin-bottom: 8px">
                  1.微信搜索「天马年报」进入小程序。
                </div>
                <div style="font-size: 14px; margin-bottom: 8px">
                  2.按提示生成年报后，点击【授权商家】。
                </div>
                <div style="font-size: 14px; margin-bottom: 8px">
                  3.务必输入授权码：<span style="color: #409eff" v-if="userInfo.auditStatus == 3">{{ userInfo.authCode }}</span><span style="color: #409eff" v-else>-</span>
                </div>
                <div style="font-size: 14px; font-weight: 600; margin-top: 15px">
                  微信账单获取方法
                </div>
                <div style="font-size: 14px; margin-bottom: 8px">
                  1.打开微信 → 我 → 服务 → 钱包 → 账单
                </div>
                <div style="font-size: 14px; margin-bottom: 8px">
                  2.右上角【常见问题】→ 下载账单 → 选择「用作证明材料」
                </div>
                <div style="font-size: 14px; margin-bottom: 15px">
                  3.时间范围：自定义最近12个月 → 发送至小程序内显示的专属邮箱
                </div>
                <div style="font-size: 14px; font-weight: 600">
                  支付宝账单获取方法
                </div>
                <div style="font-size: 14px; margin-bottom: 8px">
                  1.打开支付宝 → 我的 → 账单
                </div>
                <div style="font-size: 14px; margin-bottom: 8px">
                  2.右上角【...】→ 开具交易流水证明 → 选择「用于证明材料」
                </div>
                <div style="font-size: 14px">
                  3.交易类型：全部交易 → 时间选最近12个月 → 发送至小程序内专属邮箱
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
      </a-col>
      <a-col :span="24" :lg="14" class="mb-24">
        <CardBarChart></CardBarChart>
      </a-col>
    </a-row>

   
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div
        style="
          height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <img
          style="max-width: 100%; max-height: 100%; object-fit: contain;"
          :src="posterUrl ? posterUrl : '@/assets/sample_img.png'"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getClientStatistics } from "@/api/dashboard.js";
import { guidanceLink } from "@/utils/config.js";
// Bar chart for "Active Users" card.
import CardBarChart from "../components/Cards/CardBarChart";

// Line chart for "Sales Overview" card.
import CardLineChart from "../components/Cards/CardLineChart";

// Counter Widgets
import WidgetCounter from "../components/Widgets/WidgetCounter";

// "Projects" table component.
import CardProjectTable from "../components/Cards/CardProjectTable";

// Order History card component.
import CardOrderHistory from "../components/Cards/CardOrderHistory";

// Information card 1.
import CardInfo from "../components/Cards/CardInfo";

// Information card 2.
import CardInfo2 from "../components/Cards/CardInfo2";

// Counter Widgets stats
const stats = [
  {
    title: "剩余次数",
    value: 0,
    suffix: "",
    icon: `
    <svg t="1729235460467" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5139" width="22" height="22"><path d="M747.52 492.72832H983.04v-176.128c0-43.008-34.816-77.824-77.824-77.824H118.784C75.776 238.77632 40.96 273.59232 40.96 316.60032v546.816c0 43.008 34.816 77.824 77.824 77.824h784.384c43.008 0 77.824-34.816 77.824-77.824v-176.128H747.52c-53.248 0-98.304-43.008-98.304-98.304 0-53.248 45.056-96.256 98.304-96.256z m-2.048-331.776H444.416l96.256-94.208c30.72-30.72 79.872-30.72 110.592 0l94.208 94.208z" fill="#111827" p-id="5140"></path><path d="M698.368 589.824c0 18.432 10.24 32.768 24.576 43.008 14.336 8.192 34.816 8.192 49.152 0s24.576-24.576 24.576-43.008c0-18.432-10.24-32.768-24.576-43.008-14.336-8.192-34.816-8.192-49.152 0-14.336 10.24-24.576 26.624-24.576 43.008" fill="#111827" p-id="5141"></path></svg>
`,
  },
  {
    title: "今日使用（次）",
    value: 0,
    suffix: "",
    icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z" fill="#111827"/>
						</svg>`,
  },
];

// "Projects" table list of columns and their properties.
const tableColumns = [
  {
    title: "COMPANIES",
    dataIndex: "company",
    scopedSlots: { customRender: "company" },
    width: 300,
  },
  {
    title: "MEMBERS",
    dataIndex: "members",
    scopedSlots: { customRender: "members" },
  },
  {
    title: "BUDGET",
    dataIndex: "budget",
    class: "font-bold text-muted text-sm",
  },
  {
    title: "COMPLETION",
    scopedSlots: { customRender: "completion" },
    dataIndex: "completion",
  },
];

// "Projects" table list of rows and their properties.
const tableData = [
  {
    key: "1",
    company: {
      name: "Soft UI Shopify Version",
      logo: "images/logos/logo-shopify.svg",
    },
    members: [
      "images/face-1.jpg",
      "images/face-4.jpg",
      "images/face-2.jpg",
      "images/face-3.jpg",
    ],
    budget: "$14,000",
    completion: 60,
  },
  {
    key: "2",
    company: {
      name: "Progress Track",
      logo: "images/logos/logo-atlassian.svg",
    },
    members: ["images/face-4.jpg", "images/face-3.jpg"],
    budget: "$3,000",
    completion: 10,
  },
  {
    key: "3",
    company: {
      name: "Fix Platform Errors",
      logo: "images/logos/logo-slack.svg",
    },
    members: ["images/face-1.jpg", "images/face-2.jpg", "images/face-3.jpg"],
    budget: "Not Set",
    completion: {
      label: "100",
      status: "success",
      value: 100,
    },
  },
  {
    key: "4",
    company: {
      name: "Launch new Mobile App",
      logo: "images/logos/logo-spotify.svg",
    },
    members: ["images/face-1.jpg", "images/face-2.jpg"],
    budget: "$20,600",
    completion: {
      label: "100",
      status: "success",
      value: 100,
    },
  },
  {
    key: "5",
    company: {
      name: "Add the New Landing Page",
      logo: "images/logos/logo-jira.svg",
    },
    members: [
      "images/face-1.jpg",
      "images/face-4.jpg",
      "images/face-2.jpg",
      "images/face-3.jpg",
    ],
    budget: "$4,000",
    completion: 80,
  },
  {
    key: "6",
    company: {
      name: "Redesign Online Store",
      logo: "images/logos/logo-invision.svg",
    },
    members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-3.jpg"],
    budget: "$2,000",
    completion: {
      label: "Cancelled",
      status: "exception",
      value: 100,
    },
  },
];

export default {
  components: {
    CardBarChart,
    CardLineChart,
    WidgetCounter,
    CardProjectTable,
    CardOrderHistory,
    CardInfo,
    CardInfo2,
  },
  data() {
    return {
      posterUrl: "",
      previewVisible: false,
      // Associating table data with its corresponding property.
      account: "",
      tableData,
      userInfo: {},
      // Associating table columns with its corresponding property.
      tableColumns,
      MonthlyUsage: [],
      // Counter Widgets Stats
      stats,
      text1: "",
      text2: "",
    };
  },
  created() {
  //  this.generateWallet()
    this.getClientStatistics();
  },
  mounted() {
    let userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      this.text1 =
        "麻烦提供最近12个月的账单，操作步骤如下：为了更好给您提供服务，请提供下【微信】【支付宝】最近12个月的账单具体操作教程，请扫描海报的二维码查看投递。";
      this.account = this.userInfo.bizEmail;
      this.text2 = `麻烦提供最近12个月账单，操作步骤如下：微信操作方法：打开微信钱包 -> 点进去右上角"账单" -> 右上 角"常见问题"  -> "下载账单" -> "用作证明材料"(一定要选这个) -> "自定义" 选择最近近12个月 ->  发送至邮箱  ${this.account} 
      支付宝操作方法：点击右下角我的 -> 点击账单 -> 点击右上角"..." ->  "开具交易流 水证明" -> "用于证明材料"(一定要选这个) -> 申请交易类型选择全部交易，时间范围选择最近12个月 -> 点"下一步" -> 发送至${this.account})`;
    }
  },
  methods: {
    goToAuth() {
      this.$router.push({
        path: '/setting',
        query: {
          tab: 'auth'
        }
      });
    },
    downloadPic() {
      fetch(this.posterUrl).then((res) => {
        var link = document.createElement("a");

        link.download = "" + ".jpg";

        res.blob().then((file) => {
          link.href = URL.createObjectURL(file);

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
        });
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    copyFun(type) {
      // 获取元素内容
      let text = "";
      if (type == 1) {
        text = this.text1;
      }
      if (type == 2) {
        text = this.text2;
      }
      // 创建一个临时的输入框来存储文本
      const input = document.createElement("input");
      input.value = text;

      // 将输入框添加到页面，但不显示
      document.body.appendChild(input);
      input.select(); // 选择输入框的内容

      // 执行复制命令
      document.execCommand("copy");
      this.$message.success("复制成功");
      // 移除临时输入框
      document.body.removeChild(input);
    },
    getClientStatistics() {
      getClientStatistics().then((res) => {
        this.stats[0].value = res.balance;
        this.stats[1].value = res.todayUsage;
        this.MonthlyUsage = res.MonthlyUsage;
        this.posterUrl = res.posterUrl;
      });
    },
  },
};
</script>

<style lang="scss">
.avatar-uploader {
  width: auto !important;
  height: 100px;
  margin-right: 20px;
  .ant-upload {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
}
.top_box {
  display: flex;
  justify-content: space-between;
  padding: 30px 50px;
  .top_left {
    flex: 1;
    display: flex;
    .top_info {
      display: flex;
      justify-content: space-between;
      flex: 1;
      .balance_box {
        display: flex;
        align-items: center;
        min-width: 400px;
        .top_item_pre {
          font-size: 32px;
          font-weight: bold;
          margin: 0 20px;
          color: #1890ff;
        }
      }
      .top_centont {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
        margin-right: 30px;
        padding-right: 30px;
        border-right: 1px #d8d8d8 solid;
        min-width: 250px;
        .top_info_item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .top_item_left {
            width: 80px;
            text-align: right;
            margin-right: 10px;
            color: #666;
          }
          .top_item_right {
            color: #333;
            a {
              margin-left: 10px;
              color: #1890ff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.title_box {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 80px 10px 10px;
  font-weight: 700;
  font-size: 16px;
  margin-left: 0px;
  &::after {
    position: absolute;
    left: 0;
    content: "";
    width: 5px;
    height: 20px;
    background: #2a82e4;
  }
}
.text_box {
  font-size: 16px;
  font-weight: 500;
  background-color: #f5f5f5;
  padding: 10px 20px;
  color: #000;
  border-radius: 10px;
  .text_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 3px;
  }
}
.copy_text {
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}
.first_box {
  display: flex;
  align-items: flex-start;
  .first_right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    height: 175px;
  }
}
.first_img {
  height: 175px;
  margin: 0 20px;
  border-radius: 5px;
}
</style>
